<template>
  <v-app>
    <div id="material-kit">
      <div
        :class="{ 'nav-open': NavbarStore.showNavbar }"
        v-if="!$auth.loading"
      >
        <router-view
          name="header"
          :authenticated="$auth.isAuthenticated"
          :userRole="$auth.role"
          @doLogin="doLogin"
          @doLogout="doLogout"
          @goToProfile="goToProfile"
        />
        <div>
           <router-view
            :authenticated="$auth.isAuthenticated"
            :isLoading="isLoading"
            :userRole="$auth.role"
            @goToProfile="goToProfile"
            :key="$route.path"
          />
        </div>
        <router-view name="footer" />
      </div>
    </div>
  </v-app>
</template>

<script>
import { http } from '@/utils';
import { Roles } from '@/auth/roles';

export default {
  name: 'App',
  data() {
    return {
      isLoading: true,
      pendingRequests: 0,
      message: '',
    };
  },
  created() {
    http.interceptors.request.use(
      (config) => {
        this.isLoading = true;
        this.pendingRequests += 1;
        return config;
      },
      (error) => {
        this.pendingRequests -= 1;
        return Promise.reject(error);
      }
    );
    http.interceptors.response.use(
      (response) => {
        this.pendingRequests -= 1;
        if (this.pendingRequests === 0) {
          this.isLoading = false;
        }
        return response;
      },
      (error) => {
        this.pendingRequests -= 1;
        if (this.pendingRequests === 0) {
          this.isLoading = false;
        }
        return Promise.reject(error);
      }
    );
  },
  methods: {
    doLogin() {
      this.$auth.loginWithRedirect();
    },
    doLogout() {
      this.$auth.logout();
    },
    goToProfile() {
      const name = this.$auth.getUserRole() === Roles.Admin? 'index' : 'accountDetails';
      this.$router.push({ name });
    }
  },
};
</script>
